import { render, staticRenderFns } from "./bbtemplates.vue?vue&type=template&id=b4ed9ede&"
import script from "./bbtemplates.vue?vue&type=script&lang=js&"
export * from "./bbtemplates.vue?vue&type=script&lang=js&"
import style0 from "./bbtemplates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports